import {MainServices, ServiceIdToName} from "../../consts.js";

export const LOGS_TO_SHOW = 100;

export const BudgetCategoryTypes = {
    ...MainServices,
    GENERAL: "general"
};

export const BudgetIdToName = {
    [BudgetCategoryTypes.GENERAL]: "צף",
    ...ServiceIdToName
};

export const editSubAdminFields = {
    allowedPaymentsMethods: "allowedPaymentsMethods",
    allowedServices: "allowedServices",
    department: "department",
    manageDepartments: "manageDepartments",
    firstName: "firstName",
    email: "email",
    fullAddress: "fullAddress",
    budget: "budget",
    isMustProvidePurchaseOrderNumber: "isMustProvidePurchaseOrderNumber",
    phone: "phone"
};
